// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._13t3idpf span{line-height:0}\n._154ix0bf{top:var(--ds-space-negative-100,-8px)}\n._1bsbf6fq{width:18px}\n._1e0c1txw{display:flex}\n._1pbykb7n{z-index:1}\n._1xi2x0bf{right:var(--ds-space-negative-100,-8px)}\n._3um015vq{visibility:hidden}\n._4t3if6fq{height:18px}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
